import { useBrandingStore } from '@/stores/branding';
import { useIsDarkMode } from './useIsDarkMode';

const FALLBACK = '/assets/logo-placeholder.svg';

type Options = {
  /** Auth cards are always light — never use the dark logo variant. */
  forceLight?: boolean;
};

/** Logo for current theme: dark variant in dark mode when set, else light; then placeholder. */
export function useBrandingLogoSrc(options?: Options): string {
  const isDark = useIsDarkMode();
  const light = useBrandingStore((s) => s.app_logo_url);
  const dark = useBrandingStore((s) => s.app_logo_url_dark);

  if (options?.forceLight) {
    if (light.trim()) return light.trim();
    return FALLBACK;
  }

  if (isDark) {
    if (dark.trim()) return dark.trim();
    if (light.trim()) return light.trim();
    return FALLBACK;
  }
  if (light.trim()) return light.trim();
  return FALLBACK;
}
